<template>
  <div>
    <FormKit
      type="hidden"
      :name="`components[${index}][component_type]`"
      :value="component.component_type"
    />

    <FormKit
      label="Titel"
      type="text"
      :name="`components[${index}][title]`"
      :value="component.title"
      @input="(value) => update('title', value)"
    />

    <FormKit
      label="Eyebrow"
      type="text"
      :value="component.eyebrow"
      :name="`components[${index}][eyebrow]`"
      @input="(value) => update('eyebrow', value)"
    />

      <label>
          Geselecteerde regio's
      </label>

    <VSelect
      multiple
      :options="regions"
      v-model="selectedRegions"
      :reduce="(region) => region.value"
    >
      <template #search="{ attributes, events }">
        <input
          label="Regions"
          :name="`components[${index}][regions]`"
          v-on="events"
          v-bind="attributes"
          style="border: none"
        />
      </template>
    </VSelect>

    <FormKit
      type="hidden"
      v-for="(id, regionIndex) in component.regions"
      :key="id"
      :value="id"
      :name="`components[${index}][regions][${regionIndex}]`"
    />
  </div>
</template>

<script>
import mixin from "../mixins/component";
import axios from "axios";

export default {
  name: "PageRegionSlider",
  mixins: [mixin],
  async created() {
    this.component.regions = Object.values(this.modelValue.regions ?? []);

    const {
      data: { data: regions },
    } = await axios.get("/api/v1/regions?limit=1500");

    this.regions = regions.map((region) => ({
      label: region.name,
      value: region.id,
    }));
  },
  data() {
    return {
      regions: [],
      selectedRegions: [
        ...(Object.values(this.modelValue?.regions ?? []).map((id) =>
          Number(id)
        ) ?? []),
      ],
    };
  },
  watch: {
    selectedRegions() {
      this.component.regions = [...this.selectedRegions];
    },
  },
};
</script>
